import type { Pp2ViewModel } from "../pp2ViewModel";
import type { Pp2Link } from "../shared/links";

/** Name block offset from the element above it (spec 3.3, R4). */
export type NameBlockOffset = "afterLogo" | "afterHero" | "none";

export const nameBlockOffset = (vm: Pick<Pp2ViewModel, "heroUrl" | "logoUrl">): NameBlockOffset => {
  if (vm.logoUrl) {
    return "afterLogo";
  }
  return vm.heroUrl ? "afterHero" : "none";
};

/** The hours status item: "Open now" / "Closed now", then " · {line}" when there is a line (spec 5.1). */
export type HoursStatus = { isOpen: boolean; label: string; line: string | null };

export type QuickContact =
  { kind: "hours"; status: HoursStatus } | { kind: "phone" | "email" | "website"; link: Pp2Link };

/** Quick-contacts row items in the spec order (R5): hours status, phone, email, website. Only set items. */
export function buildQuickContacts(vm: Pick<Pp2ViewModel, "hours" | "phone" | "email" | "website">): QuickContact[] {
  const items: QuickContact[] = [];
  if (vm.hours) {
    items.push({
      kind: "hours",
      status: { isOpen: vm.hours.isOpen, label: vm.hours.statusLabel, line: vm.hours.statusLine.trim() || null },
    });
  }
  if (vm.phone) {
    items.push({ kind: "phone", link: vm.phone });
  }
  if (vm.email) {
    items.push({ kind: "email", link: vm.email });
  }
  if (vm.website) {
    items.push({ kind: "website", link: vm.website });
  }
  return items;
}
